import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = ({ theme = 'dark' }) => {
  const navigate = useNavigate();
  const isDark = theme === 'dark';

  const styles = {
    footer: {
      background: isDark ? 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' : 'linear-gradient(135deg, #dbeafe 0%, #e0e7ff 50%, #dbeafe 100%)',
      borderTop: isDark ? '1px solid rgba(102, 126, 234, 0.2)' : '1px solid rgba(0, 0, 0, 0.1)',
      padding: '40px 20px 20px',
      marginTop: '0px',
      color: isDark ? '#b0b0b0' : '#6b7280',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '60px',
      maxWidth: '800px',
      margin: '0 auto',
    },
    section: {
      minWidth: '200px',
    },
    brand: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '15px',
    },
    logo: {
      width: '32px',
      height: '32px',
    },
    brandName: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: isDark ? '#ffffff' : '#1f2937',
    },
    tagline: {
      fontSize: '0.9rem',
      lineHeight: '1.6',
      maxWidth: '300px',
    },
    sectionTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      marginBottom: '15px',
      color: isDark ? '#ffffff' : '#1f2937',
    },
    linkList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    link: {
      color: isDark ? '#b0b0b0' : '#6b7280',
      textDecoration: 'none',
      fontSize: '0.9rem',
      cursor: 'pointer',
      transition: 'color 0.2s',
    },
    bottom: {
      borderTop: isDark ? '1px solid rgba(102, 126, 234, 0.1)' : '1px solid rgba(0, 0, 0, 0.08)',
      paddingTop: '20px',
      textAlign: 'center',
      fontSize: '0.85rem',
    },
  };

  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.section}>
            <div style={styles.brand}>
              <img src="/icon.png" alt="Recapify" style={styles.logo} />
              <span style={styles.brandName}>Recapify</span>
            </div>
            <p style={styles.tagline}>
              Never forget. Never miss. Never ask twice. Your searchable AI knowledge base for all recordings.
            </p>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Legal</h3>
            <ul style={styles.linkList}>
              <li>
                <a
                  style={styles.link}
                  onClick={() => handleLinkClick('/privacy')}
                  onMouseOver={(e) => e.target.style.color = '#667eea'}
                  onMouseOut={(e) => e.target.style.color = isDark ? '#b0b0b0' : '#6b7280'}
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  style={styles.link}
                  onClick={() => handleLinkClick('/terms')}
                  onMouseOver={(e) => e.target.style.color = '#667eea'}
                  onMouseOut={(e) => e.target.style.color = isDark ? '#b0b0b0' : '#6b7280'}
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Contact</h3>
            <ul style={styles.linkList}>
              <li style={{ fontSize: '0.9rem' }}>
                <a
                  href="mailto:support@recapifyapp.com"
                  style={styles.link}
                  onMouseOver={(e) => e.target.style.color = '#667eea'}
                  onMouseOut={(e) => e.target.style.color = isDark ? '#b0b0b0' : '#6b7280'}
                >
                  support@recapifyapp.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div style={styles.bottom}>
          © {new Date().getFullYear()} Recapify. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
